// Which browser this panel was opened in, as the shop's tracker already knows
// it.
//
// The shop and the chat each had a device id and they were not the same one.
// The tracker's lives in the shop's own storage (`_mvr_vid`, written by the
// SDK); the panel runs in a frame on our domain, which is a different origin
// with its own storage, so it could not read it and invented nothing in its
// place. The guest session was therefore created against a device the tracker
// had never heard of, and the two halves of a visit could not be joined.
//
// The cost was not theoretical: of 37,046 anonymous browsing records on dev,
// not one could be matched to a customer, and they cannot be repaired after
// the fact. So the SDK now puts its id in the frame's address and the guest
// session carries it, which is the only moment the link can be made.
//
// A leaf module, for the same reason as embedOrg.js: this is needed while the
// app is still being imported.

// The SDK writes eight random bytes as hex (sdk/src/utils/visitor-id.js).
// Anything else in this parameter did not come from the tracker, and sending
// it on would file a visit against a device id that exists nowhere else.
//
// This is a shape check and nothing more. The panel's address is open to
// anyone, so this value is a hint about which visit to join, never a claim
// about who somebody is - the token decides that, and the token comes from
// the backend.
const TRACKER_ID_SHAPE = /^[0-9a-f]{16}$/;

export const getEmbeddedVisitorId = () => {
  try {
    const value = new URLSearchParams(window.location.search).get("visitorId");
    const trimmed = typeof value === "string" ? value.trim() : "";
    return TRACKER_ID_SHAPE.test(trimmed) ? trimmed : null;
  } catch (e) {
    // No window, or an address the browser will not parse: the panel is
    // standing on its own rather than embedded in a shop, so there is no
    // tracker and no id to pass on.
    return null;
  }
};
